import { configureStore } from '@reduxjs/toolkit'
import userReducer from "./features/userSlice.js"
import userAddressInfoReducer from "./features/userAddressInfoSlice.js"
import rideFlowReducer from "./features/rideFlowSlice.js"
import { authApi } from './api/authApi.js';
import { userApi } from './api/userApi.js';
import { bookingApi } from './api/bookingApi.js';
import { driverApi } from './api/driverApi.js';

export const store = configureStore({
    reducer: {
      auth: userReducer,
      userAddressInfo: userAddressInfoReducer,
      rideFlow: rideFlowReducer,
        [authApi.reducerPath]: authApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [bookingApi.reducerPath]: bookingApi.reducer,
        [driverApi.reducerPath]: driverApi.reducer,
      },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([ authApi.middleware, userApi.middleware, bookingApi.middleware, driverApi.middleware]),
});